<template>
  <label class="check-wrap" :class="{ 'is-disabled': disabled }">
    <input
      type="radio"
      style="display: none"
      :disabled="disabled"
      :value="nativeValue"
      v-model="dataValue"
    />
    <span class="check">
      <i class="iconfont icon-noselect"></i>
      <i class="iconfont icon-select"></i>
    </span>
  </label>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number, Boolean, Object]
    },
    nativeValue: {
      type: [String, Number, Boolean, Object],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dataValue: this.value
    };
  },
  watch: {
    value(val) {
      this.dataValue = val;
    },
    dataValue(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./check.scss";
</style>
